import { ReactNode, useState } from "react";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";

type Props = {
	disabled?: boolean;
	button: ReactNode;
	title: string;
	details: string | React.ReactNode;
	confirmAction: string;
	cancelAction: string;
	onConfirm: () => void;
	onCancel: () => void;
};

export function ConfirmButton({
	disabled,
	button,
	title,
	details,
	confirmAction,
	cancelAction,
	onConfirm,
	onCancel,
}: Props) {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		if (!disabled) {
			setOpen(true);
		}
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			<Box onClick={handleClickOpen}>{button}</Box>
			<Dialog open={open} onClose={handleClose} disableRestoreFocus>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					<DialogContentText>{details}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							onConfirm();
							handleClose();
						}}
					>
						{confirmAction}
					</Button>
					<Button
						onClick={() => {
							onCancel();
							handleClose();
						}}
					>
						{cancelAction}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
